















import { mapActions } from 'vuex'
import { ADD_TOAST_MESSAGE } from 'vuex-toast'
import AbstractAuthForm from '@/abstract/AuthForm'
import AuthLayout from '@/layout/AuthLayout.vue'
import Language from '@/components/Language/Language.vue'
import EmailButton from '@/components/EmailButton/EmailButton.vue'
import { AUTH__REGISTER_REQUEST } from '@/store/actions'
import { isDevelopHost } from '@/constants/enviroment'

export default AbstractAuthForm.extend({
  components: {
    AuthLayout,
    Language,
    EmailButton,
  },

  data() {
    return {
      isRegistering: false,
      isDevelopHost,
    }
  },

  computed: {
    /** Form Title Text */
    titleText(): string {
      if (this.isRegistering) {
        return this.$tc('auth.confirmEmail')
      }
      return this.$tc('auth.register')
    },

    /** Form Description Text */
    text(): string {
      if (this.isRegistering) {
        return this.$tc('auth.confirmAccountProcessText', 1, {
          email: this.authEmail,
        })
      }
      return ''
    },
  },

  methods: {
    ...mapActions([AUTH__REGISTER_REQUEST]),

    /** Register Action Call */
    register(): void {
      this[AUTH__REGISTER_REQUEST]()
        .then(() => {
          this.isRegistering = true
          this.$store.dispatch(ADD_TOAST_MESSAGE, {
            text: this.$tc('auth.confirmAccountProcess'),
          })
        })
        .catch(() => {
          this.isRegistering = false
        })
    },

    /** Reset Registration Form */
    reset(): void {
      this.isRegistering = false
      this.resetAuthEmail()
    },
  },
  metaInfo() {
    return { title: this.$tc('auth.register') }
  },
})
